import BlockContent from "@sanity/block-content-to-react";
import cn from "classnames";
import Header from "components/header";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { blogPostQuery, sanityImageConfig } from "./api";
import styles from "./blog.module.css";

export default function OnePost() {
  const { slug } = useParams();
  const { data: postData, isLoading } = useQuery(blogPostQuery(slug ?? ""));

  return (
    <>
      {isLoading || !postData ? (
        <>
          <Header />
          <div className="skeleton-animation h-96 bg-gray-600" />
          <div className={cn("bg-white max-w-screen-md w-full mx-auto px-10 pt-10 pb-20 -mt-40 flex flex-col")}>
            <div className="skeleton-animation text-4xl font-bold text-center mt-4 mb-8 h-10 w-full sm:w-[450px] self-center rounded-lg"></div>
            <div className="mb-6">
              <div className="skeleton-animation w-full h-[27px] rounded-lg mb-3"></div>
              <div className="skeleton-animation w-11/12 h-[27px] rounded-lg mb-3"></div>
              <div className="skeleton-animation w-11/12 h-[27px] rounded-lg mb-3"></div>
              <div className="skeleton-animation w-9/12 h-[27px] rounded-lg mb-3"></div>
            </div>
            <div className="mb-6">
              <div className="skeleton-animation w-full h-[27px] rounded-lg mb-3"></div>
              <div className="skeleton-animation w-11/12 h-[27px] rounded-lg mb-3"></div>
              <div className="skeleton-animation w-11/12 h-[27px] rounded-lg mb-3"></div>
              <div className="skeleton-animation w-9/12 h-[27px] rounded-lg mb-3"></div>
            </div>
          </div>
        </>
      ) : (
        <>
          <Header />
          <div
            style={{
              backgroundImage: `linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(${postData.mainImage.asset.url})`,
            }}
            className="h-96 bg-cover bg-no-repeat bg-center p-8 flex flex-col justify-end mb-10"
          />
          <div className={cn("bg-white max-w-screen-md w-full mx-auto px-10 pt-10 pb-20 -mt-40")}>
            <h1 className="text-4xl font-bold text-center mb-8">{postData.title}</h1>
            <BlockContent
              blocks={postData.body}
              projectId={sanityImageConfig.projectId}
              dataset={sanityImageConfig.dataset}
              className={styles.body}
            />
          </div>
        </>
      )}
    </>
  );
}
